export default __webpack_public_path__ + "static/b_cita_nissan-b9c6dfb5d14c44ce5fe1470c2600662e.png";